import React from 'react';

const MAX_POSES = 5;

const ReferencePoses = ({ poses, onChange }) => {
  const currentPoses = poses || [];

  const handleUpload = (shotIndex, e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (ev) => {
      const next = [...currentPoses];
      // Ensure array is long enough
      while (next.length <= shotIndex) next.push(null);
      next[shotIndex] = ev.target.result;
      onChange(next);
    };
    reader.readAsDataURL(file);
    e.target.value = '';
  };

  const handleRemove = (shotIndex) => {
    const next = [...currentPoses];
    next[shotIndex] = null;
    onChange(next);
  };

  // Always show at least 3 slots
  const slotCount = Math.max(3, currentPoses.filter(Boolean).length + 1, currentPoses.length);
  const slots = Array.from({ length: Math.min(slotCount, MAX_POSES) }, (_, i) => i);

  return (
    <div style={{
      padding: '12px', background: '#f5f5f5', borderRadius: 4,
      border: '1px solid #e0e0e0', marginBottom: 16
    }}>
      <div style={{ fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 8 }}>
        Reference Poses
      </div>
      <p style={{ fontSize: 11, color: '#999', margin: '0 0 10px' }}>
        Upload reference pose images for this pricelist. These will be available as reference images when building looks.
      </p>

      <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
        {slots.map(i => (
          <div key={i} style={{ textAlign: 'center' }}>
            <div style={{ fontSize: 11, fontWeight: 500, color: '#555', marginBottom: 4 }}>
              Shot {i + 1}
            </div>
            {currentPoses[i] ? (
              <div style={{ position: 'relative' }}>
                <img
                  src={currentPoses[i]}
                  alt={`Shot ${i + 1}`}
                  style={{
                    width: 80, height: 100, objectFit: 'cover',
                    borderRadius: 4, border: '1px solid #ddd', display: 'block'
                  }}
                />
                <div style={{ display: 'flex', gap: 2, marginTop: 4, justifyContent: 'center' }}>
                  <label style={{
                    fontSize: 9, padding: '2px 6px', background: '#e3f2fd',
                    border: '1px solid #90caf9', borderRadius: 3, cursor: 'pointer'
                  }}>
                    Replace
                    <input
                      type="file"
                      accept="image/*"
                      onChange={e => handleUpload(i, e)}
                      style={{ display: 'none' }}
                    />
                  </label>
                  <button
                    onClick={() => handleRemove(i)}
                    style={{
                      fontSize: 9, padding: '2px 6px', background: '#ffebee',
                      border: '1px solid #ef9a9a', borderRadius: 3, cursor: 'pointer'
                    }}
                  >
                    Remove
                  </button>
                </div>
              </div>
            ) : (
              <label style={{
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                width: 80, height: 100, borderRadius: 4,
                border: '2px dashed #ccc', cursor: 'pointer',
                background: '#fff', fontSize: 10, color: '#999',
                flexDirection: 'column', gap: 2
              }}>
                <span style={{ fontSize: 18, lineHeight: 1 }}>+</span>
                Upload
                <input
                  type="file"
                  accept="image/*"
                  onChange={e => handleUpload(i, e)}
                  style={{ display: 'none' }}
                />
              </label>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReferencePoses;
